<mat-toolbar class="topbar mat-bg-card" [style.background]="checkTheme() ? '#1d2130' : ''">
  <!-- Sidenav toggle button -->
  <button mat-icon-button id="sidenavToggle" (click)="toggleSidenav()" matTooltip="Expand/Collapse Menu"
    [style.color]="checkTheme() ? '#fff' : ''">
    <mat-icon>menu</mat-icon>
  </button>
  <span *ngIf="!isMobile" class="ml-16" [style.color]="checkTheme() ? '#fff' : ''" fxLayout="row"
    fxLayoutAlign="center center"><span style="font-weight: 700; font-family: 'Roboto'; color: #3e3e3e">
      {{titleMenu}}</span>
    <a class="pl-8" (click)="handleHelp()" matTooltip="Trợ giúp" fxLayout="row" fxLayoutAlign="center center"
      *ngIf="helperLink && isDisplayHelp">
      <mat-icon fxLayout="row" fxLayoutAlign="center center" style="height: 32px">help_outline</mat-icon>
    </a></span>
  <!-- Search form -->
  <!-- <div fxFlex fxHide.lt-sm="true" class="search-bar">
    <form class="top-search-form">
      <mat-icon role="img">search</mat-icon>
      <input autofocus="true" placeholder="Search" type="text" />
    </form>
  </div> -->

  <span fxFlex></span>

  <!-- <egret-search-input-over placeholder="Country (e.g. US)" resultPage="/search"> -->
  <!-- </egret-search-input-over> -->
  <!-- Open "views/search-view/result-page.component" to understand how to subscribe to input field value -->

  <!-- Notification toggle button -->
  <!-- Top left user menu -->
  <button mat-icon-button [matMenuTriggerFor]="accountMenu" class="topbar-button-right img-button">
    <img [src]="user.avatarUrl || 'assets/images/face-7.jpg'" alt="" style="object-fit: cover"
      [matTooltip]="user.fullName" />
  </button>

  <mat-menu #accountMenu="matMenu">
    <button mat-menu-item routerLink="/profile/overview">
      <mat-icon>account_box</mat-icon>
      <span>Account</span>
    </button>
    <button mat-menu-item (click)="jwtAuth.logout()">
      <mat-icon>exit_to_app</mat-icon>
      <span>Log out</span>
    </button>
  </mat-menu>
</mat-toolbar>